import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MorningMinutesComponent } from '../morning-minutes-component/morning-minutes-component';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-morning-minutes',
  templateUrl: 'morning-minutes.html',
})
export class MorningMinutesPage {
  @ViewChild('morningMinutesComponent') morningMinutesComponent: MorningMinutesComponent;
  config = AppConfig.settings;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
  ) {
  }

  ionViewDidLoad() {

  }

  ionViewDidEnter() {
    this.morningMinutesComponent.reEnterComponent();
  }

  ionViewWillLeave() {
    this.morningMinutesComponent.saveBeforeLeavingComponent();
  }

}



// WEBPACK FOOTER //
// ./src/pages/morning-minutes/morning-minutes/morning-minutes.ts